import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { ResponseData } from '@/types/http';
import { getStorage, saveLocalStorage } from '@/utils/browsers';
import { GeneralApi } from '@/apis';
import moment from 'moment';
import { DISPLAY_MOMENT_DATE_YMD } from '@/configs/constants';
import { AdministrativeDataResponse } from '@/types/administrative';

export default class GeneralStore extends BaseStore {
    api: GeneralApi;
    administrativeUnit: AdministrativeDataResponse = getStorage('administrative', true);

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            administrativeUnit: observable,
            getAdministrativeUnit: flow.bound,
            getPlaceAutoComplete: flow.bound
        });
        this.api = new GeneralApi();
    }

    *getAdministrativeUnit() {
        try {
            const res: ResponseData<AdministrativeDataResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getAdministrativeUnit, undefined, { hideLoading: true });
            if (res?.ok) {
                this.administrativeUnit = res?.data;
                saveLocalStorage('getAdministrativeDate', moment().format(DISPLAY_MOMENT_DATE_YMD));
                saveLocalStorage('administrative', JSON.stringify(res?.data));
            }
        } catch (error) {
        }
    }

    *getPlaceAutoComplete(params) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getPlaceAutoComplete, params, { hideLoading: true });
            if (res?.ok) {
                return res.data;
            }
        } catch (error) {
        }
    }
}
